/* eslint-disable no-tabs */
import React from 'react';
import PropTypes from 'prop-types';

const SymbolEdit = ({ fill, style, ...rest }) => (
  <svg
    {...rest}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 17.789 17.679"
    style={{ enableBackground: 'new 0 0 17.789 17.679', ...style }}
    xmlSpace="preserve"
  >
    <g>
      <path id="Path_1414" fill={fill} d="M9.422,3.673l4.5,4.5L6.56,15.534l-4.5-4.5L9.422,3.673z" />
      <path
        id="Path_1415"
        fill={fill}
        d="M17.337,2.588L15.33,0.581c-0.777-0.775-2.036-0.775-2.813,0l-1.923,1.923l4.5,4.5
		l2.243-2.243c0.6-0.598,0.602-1.569,0.005-2.169c-0.002-0.002-0.003-0.003-0.005-0.005V2.588z"
      />
      <path
        id="Path_1416"
        fill={fill}
        d="M0.012,17.055c-0.061,0.276,0.112,0.55,0.388,0.611
		c0.076,0.017,0.156,0.016,0.232-0.002l5.015-1.216l-4.5-4.5L0.012,17.055z"
      />
    </g>
  </svg>
);

SymbolEdit.propTypes = {
  fill: PropTypes.string,
  style: PropTypes.object,
  rest: PropTypes.object,
};

SymbolEdit.defaultProps = {
  fill: '#F04D4D',
  style: {},
  rest: {},
};

export default SymbolEdit;



// WEBPACK FOOTER //
// ./src/assets/SymbolEdit.jsx